var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"google-signin-btn",attrs:{"title":"Sign in with Google"},on:{"click":_vm.signIn}},[_c('img',{attrs:{"src":"/common/images/btn_google_normal.png","alt":"Sign in with Google"}})])}
var staticRenderFns = []

export { render, staticRenderFns }